<c-row>
  <c-col xs="12">
    <c-card class="mb-12">
      <c-card-header ngPreserveWhitespaces>
        <strong>Autoriza Liquidaciónes {{panelInfo.diaInicio}}</strong> <small>Proceso</small>
      </c-card-header>
      <c-card-body xs="12">
        <form [formGroup]="guardarFG">
          <c-row>
            <c-col [md]="6">
              <label> <b>Semana de Liquidación</b> </label>
              <c-row class="forBor1">
                <c-col [md]="6">
                  <label cLabel for="idPartner">Ejercicio</label>
                  <input
                    id="id"
                    cFormControl
                    formControlName="idEjercicio"
                  />
                </c-col>
                <c-col [md]="6">
                  <label cLabel for="idPartner">Semana</label>
                  <input
                    id="id"
                    cFormControl
                    formControlName="idSemana"
                  />
                </c-col>
                <c-col [md]="6" class="altDelAl">
                  <label cLabel for="idPartner">Del</label>
                  <input
                    id="id"
                    cFormControl
                    disabled="true"
                    formControlName="diaInicio"
                  />
                </c-col>
                <c-col [md]="6" class="altDelAl">
                  <label cLabel for="idPartner">Al</label>
                  <input
                    id="id"
                    cFormControl
                    disabled="true"
                    formControlName="diaFin"
                  />
                </c-col>
              </c-row>
            </c-col>

            <c-col [md]="6">
              <label> <b></b> </label>

              <c-row class="forBor2">
                <c-col [md]="12">
                  <c-row>
                    <c-col [md]="1"> </c-col>
                    <c-col [md]="2">
                      <label cLabel for="classPriceA">Planta</label>
                    </c-col>
                    <c-col [md]="6">
                      <select cSelect formControlName="idCmbPlanta">
                        <option
                          *ngFor="let opcion of listaPlantas"
                          [value]="opcion.facilityId"
                        >
                          {{ opcion.facilityDescription }}
                        </option>
                      </select>
                    </c-col>
                    <c-col [md]="3"> </c-col>
                  </c-row>
                </c-col>
                <c-col [md]="12" class="altEst">
                  <c-row>
                    <c-col [md]="1"> </c-col>
                    <c-col [md]="2">
                      <label cLabel for="idPartner">Estado</label>
                    </c-col>
                    <c-col [md]="6">
                      <select cSelect formControlName="idEstado">
                        <option
                          *ngFor="let estado of listaEstados"
                          [value]="estado.cveValue"
                        >
                          {{ estado.cveValue }} - {{ estado.description }}
                        </option>
                      </select>
                    </c-col>
                    <c-col [md]="3"> </c-col>
                  </c-row>
                </c-col>
              </c-row>
            </c-col>
          </c-row>
        </form>
        <c-col [md]="12">
          <button class="tmBA" cButton (click)="autorizar()">Autoriza</button>
        </c-col>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>
